import { DomSanitizer } from "@angular/platform-browser";

import {
  Component,
  OnInit,
  Input,
  ViewChild,
  HostListener,
  ElementRef,
  ChangeDetectorRef,
} from "@angular/core";
import * as _ from "underscore";
import { FilesManagerService } from "../../files-manager/files-manager.service";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { FormsModule } from "@angular/forms";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { NgClass, NgIf } from "@angular/common";
@Component({
  selector: "file-preview",
  templateUrl: "./file-preview.component.html",
  styleUrls: ["./file-preview.component.scss"],
  imports: [NgClass, NgIf, PdfViewerModule, FormsModule, TooltipModule],
})
export class FilePreviewComponent implements OnInit {
  @Input() viewContainerRef: any;
  @Input() url: any;
  @Input() type: any;
  @Input() sender_info: any;
  @Input() etag: any;
  @Input() page: number = 1;
  @Input() zoom: number = 1;
  @Input() file: any;
  @Input() resourceId: any = null;
  @ViewChild("FilePreviewDirective") adHost: any;

  @HostListener("document:keydown.escape", ["$event"])
  onKeydownHandler(event: KeyboardEvent) {
    this.close();
  }

  @ViewChild("downloadButton") downloadButton: ElementRef<HTMLElement>;

  totalPages: number;
  isLoaded: boolean = false;

  constructor(
    private filesManagerService: FilesManagerService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.refreshUrl();
  }

  afterLoadComplete(pdfData: any) {
    this.totalPages = pdfData.numPages;
    this.isLoaded = true;
  }

  nextPage() {
    this.page++;
  }

  prevPage() {
    this.page--;
  }

  zoomIn() {
    this.zoom = Number((this.zoom + 0.1).toFixed(1));
  }

  zoomOut() {
    this.zoom = Number((this.zoom - 0.1).toFixed(1));
  }

  refreshUrl(): void {
    //
    // if (this.resourceId == null) {
    //   this.url = this.conversationService.get_private_file(this.etag);
    // } else {
    //
    //   this.url = this.conversationService.get_private_resource(this.resourceId);
    // }

    this.filesManagerService
      .getFileDetailsByUuid(
        this.etag !== undefined ? this.etag : this.file.etag,
      )
      .subscribe((result) => {
        const data = result;
        this.file = data["file"];
        this.url = data["file"].url;
        this.type = data["file"].ext;

        this.isLoaded = true;
        this.cdr.detectChanges();
      });
  }

  downloadFile(e: any): void {
    e.preventDefault();
    this.filesManagerService.download(
      this.etag !== undefined ? this.etag : this.file.etag,
    );
  }

  close() {
    this.viewContainerRef.remove();
  }
}
